import { render } from "./BottomBarChart.vue?vue&type=template&id=4be4a6b8"
import script from "./BottomBarChart.vue?vue&type=script&lang=js"
export * from "./BottomBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__